<!--
    上课记录
    功能：课程正在上课的记录列表、进入继续上课
    说明：3.0版本只展示当前上课数据，只展示线下互动课
-->
<template>
  <div class="myRecord" v-loading="loading">
    <div class="flex ac jb">
      <div class="search-left">
        <p class="flex ac">
          <span class="search-left-title">课堂类型：</span>
          <!-- <a
            v-for="item in type"
            :key="item.value"
            :class="{on: check_type == item.value}"
            @click="searchPage({type: item.value})"
          >
            {{item.label}}
          </a> -->
          <a class="on">线下互动课</a>
        </p>
        <!-- <p class="flex ac">
          <span class="search-left-title">课堂状态：</span>
          <a
            v-for="item in status"
            :key="item.value"
            :class="{on: check_status == item.value}"
            @click="searchPage({status: item.value})"
          >
            {{item.label}}
          </a>
        </p> -->
      </div>
      <div class="fw flex ac">
        <el-form :inline="true" :model="forms" @submit.native.prevent="searchPage()">
          <el-form-item style="margin: 0 20px 20px 0;">
            <el-date-picker
              clearable
              v-model="forms.created_at"
              type="datetimerange"
              align="center"
              start-placeholder="上课开始时间(起)"
              end-placeholder="上课开始时间(尾)"
              range-separator="~"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item style="margin: 0 20px 20px 0;">
            <el-input v-model="tableSearch.preSelect.value" placeholder="请输入内容" clearable>
              <el-select v-model="tableSearch.preSelect.select" slot="prepend" style="width: 110px;">
                <el-option
                  v-for="(item, index) in tableSearch.preSelect.option"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-button slot="append" native-type="submit" :loading="loading">搜 索</el-button>
            </el-input>
          </el-form-item>
        </el-form>

        <router-link
          class="search-right el-button el-button--primary flex ac"
          to="/myClass"
        >
          <i class="el-icon-plus"></i>
          创建线下课
        </router-link>
      </div>
    </div>
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      :transfer="transfer"
    >
      <template slot-scope="props" v-if="props.listData">
        <ul v-if="props.listData.length">
          <li class="goods-li" v-for="(item, index) in props.listData" :key="index">
            <div
              class="goods-head pr"
              :class="{'line-on': item.type === 1}"
            >
              <i class="goods-state" :class="`state-${item.status}`"></i>
              <div class="goods-num flex ac">{{item.act_student_count}}</div>
            </div>

            <div class="school-center-state ac jc" :class="`state-${item.status}`"></div>

            <div class="goods-body">
              <div class="goods-top flex ac jb">
                <h3 class="elps">{{item.name}}</h3>

                <a v-if="item.status === 2" class="flex ac jc" @click="getMyScreen(item)">去上课</a>
                <a v-else-if="item.status === 1" class="flex ac jc" @click="getMyScreen(item)">未开始</a>
                <a v-else class="flex ac jc gray">已结束</a>
<!--                  <a v-else-if="item.video_count" class="flex ac jc" @click="getMyScreen(item)">回放</a>-->
              </div>

              <template v-if="$store.state.from === 'schoolCenter'">
                <p class="elps">{{item.course_title}}</p>
                <div class="flex ac jb">
                  {{item.start_time}}
<!--                  <span>查看更多</span>-->
                </div>
              </template>
              <template v-else>
                <p>教室编号：{{item.number}}</p>
                <p>时间：{{item.start_time}}</p>
              </template>
            </div>
          </li>
        </ul>
        <div class="goods-empty flex dc ac jc" v-else>
          <i></i>
          <p>暂无数据</p>
        </div>
      </template>
    </AppList>

    <div
      v-if="myScreen.show"
      v-loading.lock="myScreen.loading"
      class="my-screen"
    >
      <div
        class="my-screen-wait flex dc ac jc"
      >
        <h3 v-if="myScreen.name" class="elps" v-html="myScreen.name"></h3>
        <h4 v-if="myScreen.title" class="elps" v-html="myScreen.title"></h4>

        <p v-if="myScreen.classInfo.length" v-html="myScreen.classInfo.map(val => val.name).join('、')" class="elps"></p>
        <a class="screen-wait-start flex ac jc" @click="myScreenStart()">开始上课</a>
        <a class="flex ac jc" @click="myScreen.show = false">返回</a>
      </div>
    </div>

    <el-dialog
      :visible.sync="myScreenDialog.show"
      :title="myScreen.name"
      class="my-screen-iframe dialog-sp1 dialog-video"
      width="692px"
      :destroy-on-close="true"
      @close="searchPage"
    >
      <div
        v-loading.lock="myScreenDialog.loading"
      >
        <iframe
          id="myScreenIframe"
          :src="myScreenDialog.src"
          frameborder="0"
          width="100%"
          height="390px"
          style="display: block;"
          allow="microphone;camera;midi;encrypted-media;autoplay;fullscreen"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="myScreenError.show"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
        <span>对不起，找不到该课件！</span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="classBack">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "index.scss";
</style>


// WEBPACK FOOTER //
// src/views/MyClass/MyRecord/index.vue